import script from "./RoleEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleEdit.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import InputField from "@/components/neue/InputField.vue";
import NeueButton from "@/components/neue/NeueButton.vue";
import NeueTablist from "@/components/neue/NeueTablist.vue";
import NeueToggle from "@/components/neue/NeueToggle.vue";
import PageFooter from "@/components/PageFooter.vue";
import SaveBar from "@/components/SaveBar.vue";
import SelectInput from "@/components/neue/SelectInput.vue";
import SettingsSection from "@/components/neue/SettingsSection.vue";
import SystemUserModal from "@/components/users/SystemUserModal.vue";
import TablistGrid from "@/components/neue/TablistGrid.vue";
import TablistHeader from "@/components/neue/TablistHeader.vue";
import TablistRow from "@/components/neue/TablistRow.vue";
import TheModal from "@/components/TheModal.vue";
script.components = Object.assign({}, { InputField, NeueButton, NeueTablist, NeueToggle, PageFooter, SaveBar, SelectInput, SettingsSection, SystemUserModal, TablistGrid, TablistHeader, TablistRow, TheModal }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { InputField, NeueButton, NeueTablist, NeueToggle, PageFooter, SaveBar, SelectInput, SettingsSection, SystemUserModal, TablistGrid, TablistHeader, TablistRow, TheModal }, script.__o.components);}